(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("sbRespLib"), require("mobx"), require("mobxReact"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("sbRespUI", ["React", "sbRespLib", "mobx", "mobxReact", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["sbRespUI"] = factory(require("React"), require("sbRespLib"), require("mobx"), require("mobxReact"), require("ReactDOM"));
	else
		root["sbRespUI"] = factory(root["React"], root["sbRespLib"], root["mobx"], root["mobxReact"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 